import React, { useContext, useMemo } from 'react';

import { NavLink, Outlet } from 'react-router-dom';

import DadosUsuario from '../utils/context';
import { getSectionByKey, getVisibleItems } from '../utils/menuSections';
import '../pages/css/biDashboard.css';

const BiSectionLayout = ({ sectionKey }) => {
    const { autorizacoes = [] } = useContext(DadosUsuario);
    const section = getSectionByKey(sectionKey);
    const items = useMemo(() => getVisibleItems(section.items, autorizacoes), [autorizacoes, section]);

    return (
        <>
            <nav className='mainBox bi-dashboard-nav' aria-label={`Navegação do ${section.title}`}>
                {items.map((item) => {
                    const Icon = item.icon;
                    return (
                        <NavLink key={item.page} to={`/${item.page}`} className='bi-dashboard-nav-link'>
                            <Icon fontSize='small' />
                            <span>{item.text}</span>
                        </NavLink>
                    );
                })}
            </nav>
            <Outlet />
        </>
    );
};

export default BiSectionLayout;
